import styles from './MachineDetail.module.css';
import { useTranslation } from 'react-i18next';

const MachineDetali = ({ machine }) => {
  const { t, i18n } = useTranslation();
  return (
    <div className={styles.machineDetailContainer}>
      <div className={styles.textContainer}>
        <p>
          <strong>{t('name')}:</strong> {machine.naziv}
        </p>
        <p>
          <strong>{t('machineType')} :</strong> {machine.tipMasine}
        </p>
        <p>
          <strong>{t('machineRobotMachine')}:</strong> {machine.sifra}
        </p>

        <p>
          <strong>Interna oznaka robota/alata:</strong> {machine.oznakaKupac}
        </p>
        <p>
          <strong>{t('location')}:</strong> {machine.lokacija}
        </p>
      </div>
      <div className={styles.contactContainer}>
        <strong className={styles.title}>{t('contactPerson')}</strong>
        <label
          style={{ fontWeight: 'bold' }}
        >{`${machine.kontaktOsoba}`}</label>
        <label>
          <i style={{ marginRight: '10px' }} className="fas fa-phone-alt" />
          {`${machine.kontaktTelefon}`}
        </label>
        <label>
          <i style={{ marginRight: '10px' }} className="fas fa-envelope" />
          {`${machine.email}`}
        </label>
      </div>
      <div className={styles.imageContainer}>
        <img
          src={machine.slikaUrl}
          alt={`${machine.naziv}`}
          className={styles.machineImage}
        />
        {/* <button className={styles.replaceImageButton}>
          {t('replaceImage')}
        </button> */}
      </div>
    </div>
  );
};

export default MachineDetali;
